import { Button } from '@thedealersconcierge/components';
import classNames from 'classnames';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import logoutAction from '~/actions/logoutAction';
import { Link } from '~/router';

export type HeaderElement =
  | { type: 'LOGO' }
  | {
      type: 'CLOSE_AND_BACK_TO_TRANSACTION_MAIN_PAGE';
      dealershipSlug: string;
      transactionId: string;
    }
  | {
      type: 'CANCEL_AND_BACK_TO_TRANSACTION_MAIN_PAGE';
      dealershipSlug: string;
      transactionId: string;
    }
  | { type: 'CANCEL_AND_LOGOUT' }
  | { type: 'CANCEL_AND_GO_TO_LANDING_PAGE' };

/**
 *
 */
const Header: FC<{
  title: string;
  leftElement: HeaderElement;
  totalSteps?: number;
  currentStep?: number;
  className?: string;
}> = ({ title, leftElement, totalSteps, currentStep, className }) => {
  const { t } = useTranslation();

  return (
    <div className={twMerge('relative z-20', className)}>
      <div className="relative flex w-full justify-center items-center py-3.5 border-b h-14">
        <div className="absolute left-4">
          {leftElement.type === 'LOGO' && (
            <div className="relative">
              <img src="/logo.png" className="h-4" aria-label="Logo" />
            </div>
          )}

          {leftElement.type === 'CLOSE_AND_BACK_TO_TRANSACTION_MAIN_PAGE' && (
            <Link
              to="/dashboard/:dealershipSlug/:transactionId"
              params={{
                dealershipSlug: leftElement.dealershipSlug,
                transactionId: leftElement.transactionId
              }}
              className="link-small"
            >
              {t('Close')}
            </Link>
          )}

          {leftElement.type === 'CANCEL_AND_BACK_TO_TRANSACTION_MAIN_PAGE' && (
            <Link
              to="/dashboard/:dealershipSlug/:transactionId"
              params={{
                dealershipSlug: leftElement.dealershipSlug,
                transactionId: leftElement.transactionId
              }}
              className="link-small"
            >
              {t('Cancel')}
            </Link>
          )}

          {leftElement.type === 'CANCEL_AND_GO_TO_LANDING_PAGE' && (
            <Link to="/" className="link-small">
              {t('Cancel')}
            </Link>
          )}

          {leftElement.type === 'CANCEL_AND_LOGOUT' && (
            <Button
              label={t('Cancel')}
              variant="GHOST"
              size="XSMALL"
              onClick={logoutAction}
            />
          )}
        </div>

        {title && <h4 className="heading-04">{title}</h4>}
      </div>

      {!!totalSteps && !!currentStep && (
        <div className="flex flex-row w-full absolute top-14 gap-3 justify-center bg-primary p-6">
          {Array.from(Array(totalSteps)).map((_step, index) => {
            return (
              <div
                key={index}
                className={classNames('size-2.5 rounded-full', {
                  'bg-gray-300': index >= currentStep,
                  'bg-interactive-primary': index < currentStep
                })}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Header;
